export default class Error404 extends Error {}
